{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdaten",
      "class": "flex flex-row w-full",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "",
              "name": "belegdatum",
              "class": ""
            }
          ]
        },
        {
          "type": "text",
          "title": "",
          "text": "Neu",
          "class": "bg-secondary text-secondary-contrast rounded-full px-2 ml-2",
          "visible": {
            "name": "property",
            "property": "neuerBeleg",
            "rule": {
              "name": "boolean",
              "value": true
            }
          }
        }
      ]
    },
    {
      "type": "entity",
      "title": "",
      "name": "konto",
      "endpoint": "",
      "format": "{{number}} - {{name}}",
      "class": "font-bold"
    },
    {
      "type": "group",
      "control": "div",
      "title": "Belegart",
      "class": "flex flex-row w-full",
      "definitions": [
        {
          "type": "select",
          "name": "kzbelegart",
          "title": "",
          "options": [
            {
              "value": "R",
              "title": "Eingangsrechnung"
            },
            {
              "value": "G",
              "title": "Gutschrift"
            },
            {
              "value": "E",
              "title": "Buchungsbrief"
            },
            {
              "value": "K",
              "title": "Gekürzte Rechnung"
            },
            {
              "value": "H",
              "title": "Nachbelastung"
            },
            {
              "value": "T",
              "title": "Teilrechnung"
            },
            {
              "value": "U",
              "title": "Schlussrechnung"
            },
            {
              "value": "AR",
              "title": "Ausgangsrechnung"
            }
          ],
          "control": "dropdown",
          "visible": {
            "name": "not",
            "rule": {
              "name": "property",
              "property": "belegart.id",
              "rule": {
                "name": "equal",
                "value": "Warenzugang"
              }
            }
          }
        },
        {
          "type": "text",
          "title": "",
          "text": "Lieferschein",
          "class": "",
          "visible": {
            "name": "property",
            "property": "belegart.id",
            "rule": {
              "name": "equal",
              "value": "Warenzugang"
            }
          }
        }
      ]
    },
    {
      "type": "string",
      "title": "StreckenNr. / Lfd.Nr.",
      "name": "belegnummer",
      "visible": {
        "name": "not",
        "rule": {
          "name": "property",
          "property": "belegnummer",
          "rule": {
            "name": "equal",
            "value": 0
          }
        }
      }
    },
    {
      "type": "string",
      "title": "FremdbelegNr. / RechnungsNr.",
      "name": "bezugsnummer"
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "titleClass": "text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "visible": {
        "name": "not",
        "rule": {
          "name": "property",
          "property": "belegart.id",
          "rule": {
            "name": "equal",
            "value": "Warenzugang"
          }
        }
      }
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "gesamtIncl",
      "codeName": "currency",
      "titleClass": "text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "visible": {
        "name": "not",
        "rule": {
          "name": "property",
          "property": "belegart.id",
          "rule": {
            "name": "equal",
            "value": "Warenzugang"
          }
        }
      }
    }
  ]
}
